import { useMediaQuery as useEditorSupportMediaQuery } from "@prismicio/editor-support/React"

type Breakpoint = keyof typeof breakpointToWidth

// Breakpoints inspired from: https://primer.style/foundations/layout#responsive-foundations.
const breakpointToWidth = {
  small: 768,
  medium: 1012,
  large: 1280,
}

type UseMediaQueryArgs =
  | { min: Breakpoint; max?: undefined }
  | { min: Breakpoint; max: Breakpoint }
  | { min?: undefined; max: Breakpoint }

export function useMediaQuery({ min, max }: UseMediaQueryArgs): boolean {
  let query

  if (min && max) {
    const minWidth = breakpointToWidth[min]
    const maxWidth = breakpointToWidth[max]
    query = `screen and (${minWidth}px <= width < ${maxWidth}px)`
  } else if (min) {
    const minWidth = breakpointToWidth[min]
    query = `screen and (width >= ${minWidth}px)`
  } else {
    const maxWidth = breakpointToWidth[max]
    query = `screen and (width < ${maxWidth}px)`
  }

  return useEditorSupportMediaQuery(query)
}
